import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { languages } from '../../../config/language.config';
import { UserCircle, Network } from '../../icons';
import Dropdown from '../Dropdown';
import Text from '../Text';
import { StyledHeader, StyledHeaderNavigation, StyledDropdownContainer, StyledUserAndLanguage, StyledLanguage, StyledCurrentUser, DropdownHeader, StyledBrand, StyledDivider, } from './Header.styles';
const Header = ({ appName, customerName, merchantName, links, appLinkAs, userDropdownAriaLabel, sidebarToggleAriaLabel, languageAriaLabel, language, onLanguageChange, toggleSidebar, ...restProps }) => {
    const navigate = useNavigate();
    const showCurrentUser = customerName || merchantName;
    const showUserLinks = !!links?.length || showCurrentUser;
    const showLanguage = language && onLanguageChange;
    const languageLinks = [
        {
            label: 'English',
            value: languages.en,
            active: language === languages.en,
        },
        {
            label: 'Français',
            value: languages.fr,
            active: language === languages.fr,
        },
    ];
    const currentPillarName = window.location.href.split('/')[3] || ' ';
    const gaDropDownAttributes = {
        'data-navigation-name': currentPillarName == 'goalsetting'
            ? 'Goals'
            : currentPillarName[0].toUpperCase() + currentPillarName.slice(1),
        'data-section-name': 'Header',
        'data-section-id': 'Header',
        'data-insight-id': 'Not applicable',
        'data-click-text': '',
        'data-type': 'Dropdown',
    };
    return (_jsx(StyledHeader, { ...restProps, children: _jsxs(StyledHeaderNavigation, { children: [_jsx(StyledBrand, { appName: appName, appLinkAs: appLinkAs, toggleSidebar: toggleSidebar, sidebarToggleAriaLabel: sidebarToggleAriaLabel }), (showLanguage || showUserLinks) && (_jsxs(StyledDropdownContainer, { children: [showLanguage && (_jsxs(StyledUserAndLanguage, { children: [_jsxs(Dropdown, { placement: 'bottom-start', offsetOptions: { mainAxis: 16, alignmentAxis: 0 }, flipOptions: { fallbackPlacements: ['bottom-end'] }, children: [_jsx(Dropdown.Toggle, { "aria-label": languageAriaLabel, children: _jsx(Network, {}) }), _jsx(Dropdown.Menu, { style: { minWidth: '124px' }, children: languageLinks.map(({ label, value, active }) => (_jsx(Dropdown.Item, { active: active, onClick: () => value !== language && onLanguageChange(value), children: label }, label))) })] }), _jsx(StyledLanguage, { children: language.toUpperCase() })] })), showLanguage && showUserLinks && _jsx(StyledDivider, { hidden: !links?.length }), showUserLinks && (_jsxs(StyledUserAndLanguage, { children: [showCurrentUser && (_jsxs(StyledCurrentUser, { children: [_jsx(Text, { size: 'md', children: customerName }), _jsx(Text, { children: merchantName })] })), !!links?.length && (_jsxs(Dropdown, { placement: 'bottom-end', offsetOptions: { mainAxis: 16, alignmentAxis: 0 }, children: [_jsx(Dropdown.Toggle, { "aria-label": userDropdownAriaLabel, children: _jsx(UserCircle, {}) }), _jsxs(Dropdown.Menu, { children: [showCurrentUser && (_jsxs(DropdownHeader, { children: [_jsx(Text, { size: 'md', children: customerName }), _jsx(Text, { size: 'sm', children: merchantName })] })), links.map(({ label, href, ...restProps }) => (_jsx(Dropdown.Item, { ...restProps, ...gaDropDownAttributes, 'data-click-text': label, onClick: () => {
                                                        if (restProps.onClick) {
                                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                            // @ts-ignore
                                                            restProps.onClick();
                                                        }
                                                        navigate(href || '');
                                                    }, children: label }, label)))] })] }))] }))] }))] }) }));
};
Header.displayName = 'Header';
Header.defaultProps = {
    appName: 'Portal',
    sidebarToggleAriaLabel: 'Toggle navigation',
    userDropdownAriaLabel: 'User dropdown',
    languageAriaLabel: 'Language',
};
export default Header;
